import { render, staticRenderFns } from "./privacyNotice.vue?vue&type=template&id=383d3f27&scoped=true&"
import script from "./privacyNotice.vue?vue&type=script&lang=js&"
export * from "./privacyNotice.vue?vue&type=script&lang=js&"
import style0 from "./privacyNotice.vue?vue&type=style&index=0&id=383d3f27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d3f27",
  null
  
)

export default component.exports